import { cancelPendingClose } from './closeDesktopListing';
import { setListingStateVisible } from './listingState';
import { trackOpenDesktopListing } from './tracking';
import { getTermValue, TJsonQuery } from '../../../../packages/JsonQuery';
import {
  selectResultsJsonQuery,
  selectResultsOffersCount,
  selectResultsSortedOfferIds,
  selectResultsStatus,
} from '../../selectors/results';
import { TThunkAction } from '../../types/redux';
import { EResultsStatus } from '../../types/results';
import { getJsonQueryWithoutRequestOnlyTerms } from '../../utils/jsonQuery/getJsonQueryWithoutRequestOnlyTerms';
import {
  failureListingOffers,
  loadListingOffersByIds,
  markListingEmpty,
  requestListingOffers,
  setPage,
  successListingOffers,
} from '../listingOffers';
import {
  invalidateListingOffersByIdsRequests,
  isActualListingOffersByIdsRequest,
  startListingOffersByIdsRequest,
} from '../listingOffers/listingOffersByIdsRequestGuard';

export const openDesktopListing = (): TThunkAction<Promise<void>> => async (dispatch, getState) => {
  cancelPendingClose();

  const state = getState();
  const offerIds = selectResultsSortedOfferIds(state);
  const offersCount = selectResultsOffersCount(state);
  const hasNoMapOffers = offerIds.length === 0;
  const isMapRequestSucceed = selectResultsStatus(state) === EResultsStatus.Succeed;
  const jsonQuery = selectResultsJsonQuery(state);
  const pageNumber = getTermValue('page')(jsonQuery as TJsonQuery) || 1;

  if (hasNoMapOffers) {
    invalidateListingOffersByIdsRequests();
    dispatch(setListingStateVisible());

    if (!isMapRequestSucceed) {
      return;
    }

    dispatch(markListingEmpty());
    dispatch(setPage(1));

    return;
  }

  const requestId = startListingOffersByIdsRequest();
  dispatch(requestListingOffers({ reset: true }));
  dispatch(setListingStateVisible());

  try {
    const {
      queryString,
      results: { jsonQuery },
    } = state;

    const listingOffers = await dispatch(
      loadListingOffersByIds({
        baseJsonQuery: getJsonQueryWithoutRequestOnlyTerms(jsonQuery as TJsonQuery),
        offerIds,
        queryString,
        responseJsonQuery: jsonQuery as TJsonQuery,
        mapPageOffersCount: offersCount,
      }),
    );

    trackOpenDesktopListing(pageNumber, listingOffers);

    if (!isActualListingOffersByIdsRequest(requestId)) {
      return;
    }

    dispatch(successListingOffers(listingOffers));
    dispatch(setPage(1));
  } catch (error) {
    if (isActualListingOffersByIdsRequest(requestId)) {
      dispatch(failureListingOffers());
    }
    trackOpenDesktopListing(1);
  }
};
